// import dynamic from 'next/dynamic';
import Chart from "react-apexcharts";

export default Chart;
